(() => {
  const productBadgeSelector = 'product-info .jdgm-preview-badge';
  const productReviewsSelector = '#judgeme_product_reviews';
  const homepageHeaderSelector = '.jdgm-cards-carousel .jdgm-header';
  const allReviewsPath = 'pages/clienti-multumiti';

  const allReviewsUrl = () => {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}${allReviewsPath}`.replace(/\/{2,}/g, '/');
  };

  const openProductReviews = () => {
    const widget = document.querySelector(productReviewsSelector);
    const panel = widget?.closest('[role="tabpanel"]');
    const tabs = panel?.closest('tabs-component');

    if (!widget || !panel || !tabs) return false;

    const reviewTab = panel.id
      ? tabs.querySelector(`[role="tab"][aria-controls="${CSS.escape(panel.id)}"]`)
      : tabs.querySelectorAll('[role="tab"]')[Number(panel.dataset.index)];

    if (!reviewTab) return false;

    const reviewTabIndex = Number(panel.dataset.index);
    if (typeof tabs.setActiveTab === 'function' && Number.isInteger(reviewTabIndex)) {
      tabs.setActiveTab(reviewTabIndex);
    } else {
      reviewTab.click();
    }
    window.history.replaceState(null, '', productReviewsSelector);

    window.setTimeout(() => {
      if (typeof tabs.scrollToTop === 'function') {
        tabs.scrollToTop();
      } else {
        tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 50);

    return true;
  };

  const decorateHomepageHeader = () => {
    document.querySelectorAll(homepageHeaderSelector).forEach((header) => {
      if (header.dataset.reviewsNavigationReady === 'true') return;

      header.dataset.reviewsNavigationReady = 'true';
      header.classList.add('reviews-navigation-link');
      header.setAttribute('role', 'link');
      header.setAttribute('tabindex', '0');
      header.setAttribute('aria-label', 'Vezi toate recenziile clienților');
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const homepageHeader = event.target.closest(homepageHeaderSelector);
      if (!homepageHeader) return;

      event.preventDefault();
      window.location.assign(allReviewsUrl());
    },
    true
  );

  window.addEventListener(
    'click',
    (event) => {
      const productBadge = event.composedPath().find(
        (node) => node instanceof Element && node.matches(productBadgeSelector)
      );
      if (!productBadge) return;

      event.preventDefault();
      event.stopPropagation();
      openProductReviews();
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    const homepageHeader = event.target.closest(homepageHeaderSelector);
    if (!homepageHeader || !['Enter', ' '].includes(event.key)) return;

    event.preventDefault();
    window.location.assign(allReviewsUrl());
  });

  const initialize = () => {
    decorateHomepageHeader();

    if (window.location.hash === productReviewsSelector) {
      window.setTimeout(openProductReviews, 0);
    }

    const observer = new MutationObserver(() => {
      decorateHomepageHeader();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
